import { render, staticRenderFns } from "./lista_permisovacacion.vue?vue&type=template&id=62af2efa&scoped=true"
import script from "./lista_permisovacacion.vue?vue&type=script&lang=js"
export * from "./lista_permisovacacion.vue?vue&type=script&lang=js"
import style0 from "./lista_permisovacacion.vue?vue&type=style&index=0&id=62af2efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62af2efa",
  null
  
)

export default component.exports